var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { AttentionSolid, CheckmarkCircleSolid, CrossCircleSolid, InfoCircleSolid, RocketSolid, } from '../icon';
import { backgroundStyle, iconStyle, wrapperStyle } from './styles';
function NotificationIcon(_a) {
    var { isCentered = false, size = 'medium', variant = 'info' } = _a, restProps = __rest(_a, ["isCentered", "size", "variant"]);
    function renderIcon() {
        switch (variant) {
            case 'success':
                return _jsx(CheckmarkCircleSolid, Object.assign({ size: size }, restProps));
            case 'warning':
                return _jsx(AttentionSolid, Object.assign({ size: size }, restProps));
            case 'error':
                return _jsx(CrossCircleSolid, Object.assign({ size: size }, restProps));
            case 'upgrade':
                return _jsx(RocketSolid, Object.assign({ size: size }, restProps));
            case 'info':
            default:
                return _jsx(InfoCircleSolid, Object.assign({ size: size }, restProps));
        }
    }
    return (_jsxs("div", Object.assign({ css: wrapperStyle({ isCentered }), "data-testid": "notification-icon" }, { children: [_jsx("div", { css: backgroundStyle({ variant }) }), _jsx("div", Object.assign({ css: iconStyle({ variant }) }, { children: renderIcon() }))] })));
}
export default NotificationIcon;
